import { Tool } from '../../types';

export const phoneTools: Tool[] = [
  {
    id: 'ringcentral',
    name: 'RingCentral',
    category: 'Phone Systems',
    description: 'Cloud-based business phone and communication system',
    pricing: ['medium', 'high'],
    features: ['mobile', 'integrations', 'security'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['enhance-customer-service', 'streamline-operations'],
    industries: ['technology', 'consulting', 'finance'],
    website: 'https://www.ringcentral.com',
    imageUrl: 'https://logo.clearbit.com/ringcentral.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'grasshopper',
    name: 'Grasshopper',
    category: 'Phone Systems',
    description: 'Virtual phone system for small businesses',
    pricing: ['low', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['enhance-customer-service', 'streamline-operations'],
    industries: ['consulting', 'creative', 'retail'],
    website: 'https://grasshopper.com',
    imageUrl: 'https://logo.clearbit.com/grasshopper.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner'],
    minTeamSize: 'solo'
  },
  {
    id: 'dialpad',
    name: 'Dialpad',
    category: 'Phone Systems',
    description: 'AI-powered cloud communications platform',
    pricing: ['medium', 'high'],
    features: ['automation', 'integrations', 'mobile'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['enhance-customer-service', 'streamline-operations'],
    industries: ['technology', 'consulting', 'marketing'],
    website: 'https://www.dialpad.com',
    imageUrl: 'https://logo.clearbit.com/dialpad.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];